<template>
  <footer id="colophon">
    <div class="footer1">
      <p>
        Back to top
      </p>
    </div>
    <div class="footer-bar">
      <div class="footer-bar-body pb-4">
        <b-row class="footer-bar-text container-fluid">
          <b-col cols="12" md="3" sm="4">
            <h3 class="footer-heading">ABOUT US</h3>
            <img
              src="../assets/footer-about.png"
              style="width: 270px;height: 119px;margin-bottom: 10px"
            />
            <p style="width: 85%;font-size:1em;color: #2F2F2F">
              AamCart is an E-Commerce online platform acting as the one-stop
              solution for all the essential needs of customers.
            </p>
            <b-btn
              class="btn"
              style="width: 80px;height: 27px;font-size:0.6em;font-weight:bold; background-color:#F69325; border:none"
              :to="'/about'"
            >
              READMORE
            </b-btn>
          </b-col>
          <b-col cols="12" md="3" sm="4">
            <h3 class="footer-heading" style="margin-left:-12px">
              LATEST BLOGS
            </h3>
            <b-row class="mt-2 mb-4">
              <img src="../assets/instapost/2.png" />
              <span
                style="width:50%; color: rgba(155, 152, 152); padding: 8% 15px"
                >Enjoy your life with healthy body</span
              >
            </b-row>
            <b-row class="mt-2">
              <img src="../assets/instapost/4.png" />
              <span
                style="width:50%; color: rgba(155, 152, 152); padding: 8% 0px 8% 10px"
                >Reason why you should choose organic</span
              >
            </b-row>
          </b-col>
          <b-col cols="12" md="3" sm="4">
            <h3 class="footer-heading">Join Aamcart</h3>
            <p class="joinam">Sell with aamcart</p>
            <p class="joinam" style="width:70%">
              Become a member of aamcart carrers
            </p>
            <p class="joinam">Advertise your product</p>
            <h3 class="followus">Follow us on</h3>
            <p>
              <a href="https://www.facebook.com/aamcart" target="_blank">
                <i
                  class="fa fa-facebook-square p-1 fa-lg"
                  style="color:#00000080"
                ></i>
              </a>
              <a href="https://twitter.com/aamcart" target="_blank">
                <i
                  class="fa fa-twitter-square p-1 fa-lg"
                  style="color:#00000080"
                ></i>
              </a>
              <a href="https://instagram.com/aamcart" target="_blank">
                <i
                  class="fa fa-instagram p-1 fa-lg"
                  style="color:#00000080"
                ></i>
                <i
                  class="fa fa-instagram-square p-1 fa-lg"
                  style="color:#00000080"
                ></i>
              </a>
              <a href="" target="_blank">
                <i
                  class="fa fa-linkedin-square p-1 fa-lg"
                  style="color:#00000080"
                ></i>
              </a>
              <a href="https://in.pinterest.com/aamcart/" target="_blank">
                <i
                  class="fa fa-pinterest-square p-1 fa-lg"
                  style="color:#00000080"
                ></i>
              </a>
            </p>
          </b-col>
          <b-col cols="12" md="3" sm="4">
            <h3 class="footer-heading">GET APPLICATION</h3>
            <p style="color:#2F2F2F ; font-size:1em">
              Download the application for easy and handy access.
            </p>
            <b-row>
              <b-col>
                <a
                  href="https://play.google.com/apps/testing/com.drillmaps.aamcart"
                  target="_blank"
                >
                  <img
                    src="../assets/google_playstore_black.png"
                    style="width: 136px;height: 41px;"
                  />
                </a>
              </b-col>
            </b-row>
            <b-row class="pt-2" style="margin-left: -18px">
              <b-col>
                <a
                  href="https://testflight.apple.com/join/80jWHbkC"
                  target="_blank"
                >
                  <img
                    src="../assets/apple_playstore_black.svg"
                    style="width: 148px;height: 45px;"
                  />
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="last-footer">
      <p>
        Copyright DrillMaps India Pvt. Ltd. {{ new Date().getFullYear() }} All
        Rights Reserved |
        <span>
          <router-link
            to="/about"
            class=""
            style="text-decoration: none; color: rgb(127, 127, 127);"
          >
            About Us
          </router-link></span
        >
        |
        <span>
          <router-link
            to="/contact"
            class=""
            style="text-decoration: none; color: rgb(127, 127, 127);"
          >
            Contact Us</router-link
          ></span
        >
        |
        <span>
          <router-link
            to="/privacy-policy"
            class=""
            style="text-decoration: none; color: rgb(127, 127, 127);"
          >
            Privacy Policy
          </router-link></span
        >
        |
        <span>
          <router-link
            to="/terms-conditions"
            class=""
            style="text-decoration: none; color: rgb(127, 127, 127);"
          >
            Term &amp; Condition</router-link
          >
        </span>
        |
        <span>
          <router-link
            to="/refund-terms"
            class=""
            style="text-decoration: none; color: rgb(127, 127, 127);"
          >
            Refund Returns &amp; Cancellation Policy</router-link
          >
        </span>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data: () => {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap");
.joinam {
  font-weight: bold;
  margin: 5px 0px;
  color: rgb(105, 105, 105);
}
.footer-heading {
  margin-bottom: 30px;
  color: #000000;
  font-size: 1em;
  letter-spacing: 0.64px;
  font-family: "Montserrat", sans-serif;
}
.followus {
  margin-top: 30px;
  color: #000000;
  font-size: 1em;
  letter-spacing: 0.64px;
  font-family: "Montserrat", sans-serif;
}
.footer-bar {
  color: black;
}
.footer-bar-body {
  /* height: 455px; */
  color: black;
  background-color: rgba(255, 255, 255, 0.7);
}
.footer-bar-text {
  padding: 50px 70px;
  margin: auto;
  /* margin-left: 150px; */
  /* margin-right: 150px; */
}
.last-footer {
  height: 59px;
  background-color: #f8f8f8;
  color: #2f2f2f97;
}
.last-footer p {
  text-align: center;
  padding-top: 20px;
  font-weight: bold;
  font-size: 14px;
}
.footer1 {
  height: 40px;
  background-color: #f8f8f8;
  color: #2f2f2f;
}
.footer1 p {
  font-size: 15px;
  text-align: center;
  padding-top: 10px;
  font-weight: bold;
}
</style>
